import { Fragment, useEffect, useState } from "react";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

function Highchart1(props) {
    const [ratio, setRatio] = useState();
    const [title, setTitle] = useState();

    useEffect(() => {
        setRatio(((props.VUL / props.POP) * 100).toFixed(1));
    }, [props]);

    useEffect(() => {

        const titleText = '<div style="color: white; font-size: 13px">취약인구비율</div>'
                        + '<div style="color: white; text-align: center; text-shadow: 1px 1px 1px black, 2px 2px 1px black, 2px 2px 2px white;">'
                        + parseFloat(ratio) +'%</div>';
        
        setTitle(titleText)
    }, [ratio, title]);

    Highcharts.setOptions({
        lang: {
            months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
            shortMonths: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
            shortWeekdays: ['<span style="color: red;">일</span>', '월', '화', '수', '목', '금', '<span style="color: blue;">토</span>'],
            weekdays: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일']
        }
    });

    
    const options = {
        chart: { 
            backgroundColor: 'transparent', height: '278px',
            marginTop: 0, marginRight: 0, marginBottom: 0, marginLeft: 0, 
            plotBackgroundColor: null, plotBorderWidth: null, plotShadow: false,
            type: 'pie', with: '100px' 
        },
        credits: { enabled: false }, exporting: { enabled: false },
        plotOptions: { pie: { allowPointSelect: false, borderWidth: 0, dataLabels: { enabled: false }, showInLegend: false } },
        title: { text: title, useHTML: true, y: 115 },
        tooltip: { enabled: false },
        series: [{
            innerSize: '60%',
            data: [
                { name: '', y: parseFloat(ratio), selected: true },
                { name: '', y: 100-parseFloat(ratio) },
            ]
        }]
    }

    return(
        <Fragment>
            <HighchartsReact highcharts={ Highcharts } options={ options } />
        </Fragment>
    )
}

export default Highchart1;